const Utils = require('../utils');

const makeEvents = (getSlotById) => {
	let infoById = {}; // { [divId]: { slot, ad, isEmpty }, ... }
	const cbs = {}; // { slotRenderEnded: [cb1, cb2], ... }
	const ensureInfoById = (id) => {
		if (!infoById[id]) {
			const slot = getSlotById(id);
			if (slot) {
				infoById[id] = { slot };
			}
		}
		return infoById[id];
	}
	const trigger = (id, type, data) => {
		const info = ensureInfoById(id);
		if (info) {
			Utils.assign(info, data, { lastEvType: type });
			cbs[type]?.forEach((cb) => Utils.withCatch(() => cb(info)));
		}
	};
	return {
		trigger,
		ensureInfoById,
		add(type, listener) {
			cbs[type] = cbs[type] || [];
			cbs[type].push(listener);
		},
		remove(type, listener) {
			cbs[type] = cbs[type]?.filter((cb) => cb !== listener);
		},
		onSlotsDestroyed() {
			infoById = {};
		},
		slotRequested({ slot }) {
			const id = slot.getSlotElementId();
			infoById[id] = { slot };
			trigger(id, 'slotRequested');
		},
	};
};

module.exports = { makeEvents };
